import React, { MouseEvent, useRef } from "react";
import type { InteractionItem } from "chart.js";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  BarController,
} from "chart.js";
import {
  Chart,
  getDatasetAtEvent,
  getElementAtEvent,
  getElementsAtEvent,
} from "react-chartjs-2";
import { faker } from "@faker-js/faker";
import { Select } from "antd";
import Colors from "../../../config/Colors";

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  BarController
);

interface IDashboardChartProps {
  users: IDashboardUsers;
}

export default function DashboardChart({ users }: IDashboardChartProps) {
  const subscribedUsersData = [
    users.Subs.Monday,
    users.Subs.Tuesday,
    users.Subs.Wednesday,
    users.Subs.Thursday,
    users.Subs.Friday,
    users.Subs.Saturday,
    users.Subs.Sunday,
  ];

  const nonSubscribedUsersData = [
    users.Non.Monday,
    users.Non.Tuesday,
    users.Non.Wednesday,
    users.Non.Thursday,
    users.Non.Friday,
    users.Non.Saturday,
    users.Non.Sunday,
  ];
  const options = {
    plugins: {
      legend: {
        position: "top" as const,
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
        },
      },
    },
  };

  const labels = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  const data = {
    labels,
    datasets: [
      {
        label: "Subscribed users",
        backgroundColor: `${Colors.appMainColor}`,
        data: subscribedUsersData,
        borderColor: "white",
        borderWidth: 2,
      },
      {
        label: "Non-subscribed users",
        backgroundColor: `${Colors.secondaryColor}`,
        data: nonSubscribedUsersData,
      },
    ],
  };

  const { Option } = Select;
  const printDatasetAtEvent = (dataset: InteractionItem[]) => {
    const first = dataset[0];
    if (!first) return;

    const datasetEntry = data.datasets[first.datasetIndex];
    if (!datasetEntry) return;

    console.log(datasetEntry.label);
  };

  const printElementAtEvent = (element: InteractionItem[]) => {
    const first = element[0];
    if (!first) return;

    const { datasetIndex, index } = first;
    const label = data.labels[index];
    const datasetEntry = data.datasets[datasetIndex];
    if (!label || !datasetEntry) return;

    console.log(label, datasetEntry.data[index]);
  };

  const printElementsAtEvent = (elements: InteractionItem[]) => {
    if (!elements.length) return;
  };

  const chartRef = useRef<ChartJS>(null);

  const onClick = (event: MouseEvent<HTMLCanvasElement>) => {
    const { current: chart } = chartRef;

    if (!chart) {
      return;
    }

    printDatasetAtEvent(getDatasetAtEvent(chart, event));
    printElementAtEvent(getElementAtEvent(chart, event));
    printElementsAtEvent(getElementsAtEvent(chart, event));
  };

  const onSortChange = (value: any) => {
    console.log(`selected ${value}`);
  };

  return (
    <div
      style={{ background: "#FFFFFF" }}
      className="shadow-5 surface-card border-round px-3"
    >
      <div className="w-12 flex flex-row justify-content-between align-items-center">
        <div
          className="pt-3"
          style={{
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "27px",
            color: `${Colors.mainTextColor}`,
          }}
        >
          User overview
        </div>
      </div>
      <div className="pb-2">
        <Chart
          ref={chartRef}
          type="bar"
          onClick={onClick}
          options={options}
          data={data}
        />
      </div>
    </div>
  );
}
